// src/components/Hero.js
import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>Freshly Baked, Just for You</h1>
        <p>Experience the aroma of artisanal bread and pastries, made with love.</p>
        <a href="#menu" className="cta-button">View Our Menu</a>
      </div>
    </section>
  );
};

export default Hero;